import AnalyticsStore from '../stores/analytics/analyticsStore'
import pageDataObject from '../../application/pageDataObject'
import { queryString } from '../../utils/window'
import { getIsNativeApp, path } from '../../utils/ua'

const analyticsServicesConditions = {
  default_services: () => true,
  slideshow_native_app_services: () => pageDataObject.isSlideshow && getIsNativeApp(),
  non_native_app_services: () => !getIsNativeApp(),
  facebook_analytics: () =>
    !getIsNativeApp() && pageDataObject.get('config.facebook_pixel') && !queryString.a_aid,
  full_layout_services: () => path.isFullLayout,
}

const supportedAnalyticsServices = pageDataObject.get('config.analytics_services')
export const analyticsServices = []
const site = NM.pdo.get('context.site')
for (const analyticsServicesGroup in supportedAnalyticsServices) {
  const condition = analyticsServicesConditions[analyticsServicesGroup]
  if (condition()) {
    const services = supportedAnalyticsServices[analyticsServicesGroup] || []
    for (const service of services) {
      analyticsServices.push(require(`../services/analytics/${service}Service`).default)
    }
  }
}

const analyticsStore = AnalyticsStore.create()

export default function init() {
  analyticsServices.forEach(function(Class) {
    Class.create({ store: analyticsStore })
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/initializers/analyticsInitializer.js